import * as React from "react";
import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkIcon } from "uitk-react-icons";
import { MobileMenuProps, DesktopMenuProps, Landmark } from "../typings";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

const generateLandmarksList = (landmarks: Landmark[]) =>
  landmarks.map((landmark: Landmark) => (
    <li key={landmark.id} tabIndex={0} onClick={landmark.onClick}>
      <UitkIcon name="place" />
      {landmark.title}
      <p className="is-visually-hidden">{landmark.description}</p>
    </li>
  ));

export const MobileMenu = (props: MobileMenuProps) => (
  <UitkCardAloha>
    <UitkCardAlohaContentSection border="bottom">
      <div className="mobile-nav-card__toggle" onClick={props.toggle}>
        <UitkLayoutFlex tabIndex={0} justifyContent="space-between">
          <UitkLayoutFlexItem>
            <div>
              <h2 className="uitk-type-heading-500">{props.title}</h2>
            </div>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <UitkIcon name={props.isOpen ? "expand_more" : "expand_less"} />
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </div>
    </UitkCardAlohaContentSection>
    <UitkCardAlohaContentSection className="map-menu">
      <ul className="map-menu__items" tabIndex={0}>
        {generateLandmarksList(props.landmarks)}
      </ul>
    </UitkCardAlohaContentSection>
  </UitkCardAloha>
);

export const DesktopMenu = (props: DesktopMenuProps) => (
  <UitkCardAloha className="map-explorer">
    <UitkCardAlohaContentSection border="bottom">
      <div tabIndex={0}>
        <h2 className="uitk-type-heading-500">{props.title}</h2>
      </div>
    </UitkCardAlohaContentSection>
    <UitkCardAlohaContentSection className="map-menu">
      <ul className="map-menu__items">{generateLandmarksList(props.landmarks)}</ul>
    </UitkCardAlohaContentSection>
  </UitkCardAloha>
);
